import { render, staticRenderFns } from "./DownloadableResourcesCard.vue?vue&type=template&id=63408a04"
import script from "./DownloadableResourcesCard.vue?vue&type=script&lang=js"
export * from "./DownloadableResourcesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports